import { Serializable } from './i-serializable';

/**
 * 아동 정보
 * @author dupark@pyundoori.com
 */
export class Child implements Serializable<Child> {

  /**
   * 아동의 나이 기본: -1
   */
  private $age: number = -1;

  /**
   * 아동의 이름 기본: 빈 문자열
   */
  private $name: string = '';

  /**
   * 아동의 회원 번호 기본: -1
   */
  private $num: number = -1;

  /**
   * 부모의 회원 번호 기본: -1
   */
  private $parentNum: number = -1;

  /**
   * 아동이 남자인지 여부 기본: true
   * @param {boolean}
   */
  private $isMale: boolean = true;

  /**
   * 아동의 레벨 기본: -1
   */
  private $level: number = -1;

  /**
   * 아동의 증상 기본: 빈 문자열
   */
  private $symptom: string = '';

  /**
   * 아동이 소속된 센터 번호
   */
  private $centerNum: number = -1;

  /**
   * 아동이 소속된 센터 지점 이름
   */
  private $centerName: string = '';

  /**
   * 아동이 소속된 센터 지점 연락처
   */
  private $centerPhone: string = '';

  /**
   * 타입없는 객체를 받아서 타입에 맞게 변환함
   * @constructor
   */
  constructor(input: Object = null) {
    if (input) {
      this.deserialize(input);
    }
  }

  /**
   * @override
   */
  deserialize(input: Object): Child {
    this.$age = parseInt(input['bmi_age'], 10);
    this.$name = input['bmi_name'];
    this.$num = parseInt(input['bmi_num'], 10);
    this.$parentNum = parseInt(input['bm_num'], 10);
    this.$isMale = input['bmi_sex'] === '남자';
    this.$level = parseInt(input['el_num'], 10);
    this.$symptom = input['sym_name'];
    this.$centerNum = input['company_num'];
    this.$centerName = input['company_name'];
    this.$centerPhone = input['company_phone'];
    return this;
  }

  /** @return {number} 아동의 나이 */
  get age(): number { return this.$age; }

  /** @return {number} 아동의 이름 */
  get name(): string { return this.$name; }

  /** @return {number} 아동의 식별번호 */
  get num(): number { return this.$num; }

  /** @return {number}  부모의 식별번호 */
  get parentNum(): number { return this.$parentNum; }

  /** @return {string} 아동의 성별, '남자' 또는 '여자' */
  get sex(): string { return this.$isMale ? '남자' : '여자'; }

  /** @return {number} 아동이 남자인지 여부 */
  get isMale(): boolean { return this.$isMale; }

  /** @return {number} 아동의 운동 레벨 */
  get level(): number { return this.$level; }

  /** @return {number} 아동의 증상 */
  get symptom(): string { return this.$symptom; }

  /** @return {number} 아동이 소속된 센터 번호 */
  get centerNum(): number { return this.$centerNum; }

  /** @return {string} 아동이 소속된 센터 지점 이름 */
  get centerName(): string { return this.$centerName; }

  /** @return {string} 아동이 소속된 센터 연락처 */
  get centerPhone(): string { return this.$centerPhone; }
}
